"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HemeSampleItems = void 0;
require("./scss/styles.scss");
const GetGSheetsData_1 = require("./Data/GetGSheetsData");
const ParseRowsToHemeSample_1 = require("./Data/ParseRowsToHemeSample");
const UIMain_1 = require("./UI/UIMain");
const UIMonitor_1 = require("./UI/UIMonitor");
const bootstrap_1 = require("bootstrap");
const UnityHandler_1 = require("./Unity/UnityHandler");
function Load() {
    // set up DOM elements first
    (0, UIMain_1.UIMainSetUp)("main", "monitor");
    (0, UIMonitor_1.UIMonitorSetUp)("monitor");
    Promise.all([
        (0, UnityHandler_1.LoadUnity)(document.getElementById('unity-canvas')),
        (0, GetGSheetsData_1.GetData)()
    ]).then((data) => {
        exports.HemeSampleItems = (0, ParseRowsToHemeSample_1.CreateHemeSamplesFromRowData)(data[1]);
        (0, UIMain_1.UIMainEventsSetUp)(exports.HemeSampleItems);
        (0, UIMonitor_1.UIQCTableSetUp)(exports.HemeSampleItems);
        (0, UIMonitor_1.UIExplorerSetUp)(exports.HemeSampleItems);
        globalThis.sheetdata = data;
        globalThis.items = exports.HemeSampleItems;
        // add tooltip
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap_1.Tooltip(tooltipTriggerEl, { placement: 'bottom' });
        });
        return { hemeSampleItems: exports.HemeSampleItems };
    });
}
Load();
